// Sample PacSana sleep history for the demo client, shaped like PacSana's
// HistoricalData series: a bare `[{ date, value }]` list in hours per day.
//
// Nights land between about 5.4 and 6.8 hours, so the daily average sits
// around six — just above the "Low Sleep" band, under PacSana's "Good Sleep".

// Clients the sample is shown for: by any of their ids (route param, Mongo _id
// or client number), or by "first last" (lower-case).
export const PACSANA_SAMPLE_CLIENT_IDS = new Set(["4403"]);
export const PACSANA_SAMPLE_CLIENT_NAMES = new Set(["bill hess"]);

const MIN_HOURS = 5.4;
const SPREAD_HOURS = 1.4;

// The same date always gets the same night, so changing the range or
// reloading doesn't reshuffle the chart.
const nightFor = (date) => {
  // FNV-1a, then a final mix so neighbouring dates land far apart.
  let hash = 2166136261;
  for (const ch of date) hash = Math.imul(hash ^ ch.charCodeAt(0), 16777619);
  hash = Math.imul(hash ^ (hash >>> 15), 2246822507);
  hash ^= hash >>> 13;
  const unit = ((hash >>> 0) % 1000) / 1000;
  return Math.round((MIN_HOURS + unit * SPREAD_HOURS) * 10) / 10;
};

const todayIso = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

/** A sleep reading for each day on the axis, up to and including today. */
export const sampleSleepHistory = (days = []) => {
  const today = todayIso();
  return days
    .filter((date) => date <= today)
    .map((date) => ({ date, value: nightFor(date) }));
};
